import React from 'react';
import { Box, IconButton, Link, Typography, useTheme } from "@mui/material"
import { ArticleNavBar } from "./styles";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ArticleData } from "./types";
import { useLocation, useNavigate } from 'react-router-dom';
import { articles } from '../../utils/data';
import { verify } from '../../utils/common';

const Article: React.FC = () => {
    const [data, setData] = React.useState<ArticleData | undefined>(undefined);
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();

    const renderImages = () => {
        return data?.images.map((item, index) => (
            <img src={item} alt={`image-${index}`} width="100%" />
        ));
    };

    const renderParagraphs = () => {
        return data?.paragraphs?.map((item) => (
            <p>{item}</p>
        ))
    };

    React.useEffect(() => {
        if (location.state?.id) {
            const article = articles.find(item => item.id === location.state.id);
            if (article) {
                setData(article);
            } else {
                navigate('/')
            }
        } else {
            navigate('/')
        }
    }, [location, navigate]);

    React.useEffect(() => {
        (async () => {
            const currentToken = localStorage.getItem("jwt");
            if (currentToken) {
                const isValid = await verify(currentToken);
                if (isValid.code) {
                    navigate("/unauthorized");
                }
            } else {
                navigate("/unauthorized");
            }
        })();
    }, [location.pathname, navigate]);

    return (
        <Box>
            <ArticleNavBar theme={theme}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography>
                    {data?.title}
                </Typography>
                <span></span>
            </ArticleNavBar>
            <img src={data?.principalImage} alt={data?.title} width="100%"></img>
            <Box textAlign="center" mt={7}>
                <Typography variant='h4' fontWeight="bold">
                    {data?.title}
                </Typography>
                <Box margin="auto" mt={4} mb={6}>
                    <Typography color="textDisabled">
                        Escrito el {data?.date}
                    </Typography>
                    <Typography color="textDisabled">
                        Comunicacion RH
                    </Typography>
                </Box>
                {renderImages()}
                {/* <Box width="800px" maxWidth="100%" margin="auto" textAlign="justify">
                    {renderParagraphs()}
                </Box> */}
                <Box margin={4}>
                    <Link color='textSecondary' href={data?.link} >
                        {data?.linkLabel}
                    </Link>
                </Box>
            </Box>
        </Box>
    )
}

export default Article;